import React, { useEffect, useMemo, useState } from 'react';
import { CustomButton, TableData } from 'components';
import { downloadProviderBalanceReportService, getAllProviderCredsService, getProviderCredBalance, updateProviderCredsService } from 'services/admin/providerService';
import { errorAlert } from 'helpers/alerts';
import { currencyFormatter, downloadFile } from 'helpers/util';
import { DownloadingOutlined } from '@mui/icons-material';
import moment from 'moment';
import { Box, Typography } from '@mui/material';
import Images from 'assets/images';
import { render } from '@testing-library/react';

const ProviderBalanceScreen = () => {
  const [providerCreds, setProviderCreds] = useState([])
  const [loading, setLoading] = useState(false)
  const date = useMemo(() => moment().format('DD-MM-YYYY HH-mm-ss'), []);

  useEffect(() => {
    setLoading(true);
    getAllProviderCredsService().then(creds => {
      let list = creds.filter(item => item.provider && !['smartgateiso', 'sandbox', 'certificacion'].includes(item.conciliacion_service));
      setProviderCreds(list);
      list.forEach(cred => {
        getProviderCredBalance([cred.id]).then(balance => {
          setProviderCreds(prev => {
            return prev.map(item => {
              const saldo = balance[0].balance;
              if (item.id === cred.id) {
                return {
                  ...item,
                  balance: saldo ? Math.abs(saldo?.disponiblePorcentual || saldo?.saldo || saldo?.balance || 0) : null
                };
              }
              return item;
            });
          })
        })
      })
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const handlerDownload = async () => {
    setLoading(true)
    downloadProviderBalanceReportService(providerCreds, date)
      .then((data) => downloadFile(data, `Saldo Proveedores (${date}).xlsx`))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const handlerSetMinBalance = async (value, row) => {
    if (row.min_balance == value) return;
    setLoading(true);
    await updateProviderCredsService(row.id, { min_balance: value })
    setProviderCreds(prev => {
      return prev.map(item => {
        if (item.id === row.id) {
          return {
            ...item,
            min_balance: value
          };
        }
        return item;
      });
    })
    setLoading(false);
  };

  return (
    <Box mt={2}>
      <Typography sx={{ position: 'absolute', fontWeight: 'bold' }} mt={1}>Fecha y hora: {date}</Typography>
      <TableData
        dataRows={providerCreds}
        loading={loading}
        headerButtons={[
          <CustomButton
            dark={true}
            icon={Images.icon.download}
            key="dowloadDetails"
            name={"Descargar"}
            loading={loading}
            click={handlerDownload}
          />,
        ]}
        dataTitle={[
          "Id",
          "Proveedor",
          "Nombre",
          "Saldo",
          "Saldo Minimo",
        ]}
        formatter={({
          identification,
          conciliacion_service,
          name_connector,
          balance,
          min_balance
        }) => ([
          identification,
          conciliacion_service,
          name_connector,
          balance != null ? currencyFormatter.format(balance) : '-',
          {
            name: "min_balance",
            type: "input",
            value: min_balance || 0,
            onBlur: handlerSetMinBalance,
            render: (value) => currencyFormatter.format(value)
          },
        ])}

      />
    </Box>
  )
}

export default ProviderBalanceScreen